import React, { useState } from 'react';
import { TextField, Button, Box, Grid,  InputLabel, FormControlLabel , RadioGroup, Radio, MenuItem, Select, IconButton, Tooltip , Icon , FormLabel } from '@material-ui/core';
import { FormControl } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import useStyles  from './useStyles'

const PasoDosForm = () => {


    const classes = useStyles();
  
      const handleChangeProfesional = (event) => {
        setProfesional(event.target.value);
      };

      const handleChangeRegion = (event) => {
        setRegion(event.target.value);
      };

      const handleChangeInstitucion = (event) => {
        setInstitucion(event.target.value);
      };
      const handleChangePais = (event) => {
        setPais(event.target.value);
      };

      const handleChangeEntidad = (event) => {
        setEntidad(event.target.value);
      };



      const [profesional, setProfesional] = React.useState('');
   
  
    const [subTitulo, setSubTitulo] = useState('Inscripción de Título o Certificado de Competencias') 
    const [selectedPais, setSelectedPais] = React.useState('');
    const [region, setRegion] = React.useState('');
    const [institucion, setInstitucion] = React.useState('');
    const [pais, setPais] = React.useState('');
    const [entidad, setEntidad] = React.useState('');
  
    return (


    <>
        <Box display="flex" justifyContent="start">
          <h3 style={{ color: '#0064AC', fontSize: 16, fontWeight: 'bold', marginLeft: 45 }}>{subTitulo}</h3>
        </Box>
        
        <FormControl className={classes.formControlComponent} >
          
            </FormControl>
        
            <Grid>

          <FormControl className={classes.formControlComponent} size="small" >
          <InputLabel id="selectlabel" variant="outlined" >Título</InputLabel>
                <Select
                required
                labelId="paislabel"
                id="paisselect"
                variant="outlined"
                value={profesional}
                label="País"
                onChange={handleChangeProfesional}
                >
                    <MenuItem value={0}>Seleccione</MenuItem>
                    <MenuItem value={1}>Acupunturista</MenuItem>
                    <MenuItem value={2}>Auxiliar de Enfermería</MenuItem>
                    <MenuItem value={3}>Auxiliar de Farmacia</MenuItem>

                </Select>

          </FormControl>
           



          <FormControl className={classes.formControlComponent}  >
          <Box display="flex" justifyContent="left">
             <FormLabel id="demo-radio-buttons-group-label" style={{ fontSize: 12, paddingTop: 0, paddingRight: 10 }} >Otorgado en:</FormLabel>
              <RadioGroup row
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
              >
               
                <FormControlLabel value="Chile" style={{  paddingTop: 5 }}  control={<Radio />} label="Chile" />
                <FormControlLabel value="Extranjero"  style={{  paddingTop: 5 }}  control={<Radio />} label="Extranjero" />
              </RadioGroup>
          </Box>
          </FormControl>
      

        </Grid>

        <Grid>

        <FormControl className={classes.formControlComponent} >
                <TextField
                      id="fechatitulacion"
                      label="Fecha de Titulación"
                      type="date"
                      size="small" 
                      variant="outlined"
                      defaultValue="2022-03-10"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                />
        </FormControl>


       
        <FormControl className={classes.formControlComponent} size="small" >
             
            <InputLabel id="selectlabel"  variant="outlined"  >Institución</InputLabel>
              <Select
                variant="outlined"
                labelId="institucionlabel"
                id="institucionselect"
                value={institucion}
                label="Institución"
                onChange={handleChangeInstitucion}
              >
              <MenuItem value={0}>Seleccione</MenuItem>
              <MenuItem value={1}>Academia Politécnica Naval</MenuItem>
              <MenuItem value={2}>ARCIS</MenuItem>
              <MenuItem value={3}>CEFONOR</MenuItem>

          
              </Select>
      
        </FormControl>          
        <Tooltip title="Institución que otorgó título profesional o certificado de competencias">
                  <text style={{ color: '#0064AC', fontSize: 14, fontWeight: 'bold' }}>!</text>
          </Tooltip>

      
        <FormControl className={classes.formControlComponent} size="small" >
          <InputLabel id="selectlabel"   variant="outlined" >Región Institución</InputLabel>
            <Select
              variant="outlined"
              labelId="regioninstlabel"
              id="regioninstselect"
              value={handleChangeRegion}
              label="Región Institución"
              onChange={handleChangeRegion}
            >
            <MenuItem value={0}>Seleccione</MenuItem>
            <MenuItem value={1}>I Región de Tarapacá</MenuItem>
            <MenuItem value={2}>II Región de Antofagasta</MenuItem>
            <MenuItem value={3}>III Región de Atacama</MenuItem>
            </Select>
        </FormControl>
   

    
        <FormControl className={classes.formControlComponent} size="small" >
          <InputLabel id="selectlabel" variant="outlined" >País de ubicación de la institución</InputLabel>
            <Select
              variant="outlined"
              labelId="paisinstlabel"
              id="paisinstselect"
              value={pais}
              label="País de ubicación de la institución"
              onChange={handleChangePais}
            >
            <MenuItem value={0}>Seleccione</MenuItem>
            <MenuItem value={1}>Afganistán</MenuItem>
            <MenuItem value={2}>Albania</MenuItem>
            <MenuItem value={3}>Alemania</MenuItem>
            </Select>
        </FormControl>
  

       
        <FormControl className={classes.formControlComponent} size="small" >
          <InputLabel id="selectlabel" variant="outlined" >Entidad</InputLabel>
            <Select
              variant="outlined"
              labelId="entidadlabel"
              id="entidadselect"
              value={entidad}
              label="Entidad"
              onChange={handleChangeEntidad}
            >
            <MenuItem value={0}>Seleccione</MenuItem>
            <MenuItem value={1}>Universidad de Chile</MenuItem>
            <MenuItem value={2}>Ministerio de Relaciones Exteriores</MenuItem>
            <MenuItem value={3}>Servicio de Salud Metropolitano Oriente</MenuItem>
            </Select>
        </FormControl>
        <Tooltip title="Entidad que otorgó el reconocimiento, revalidación o habilitación">
                  <text style={{ color: '#0064AC', fontSize: 14, fontWeight: 'bold' }}>!</text>
          </Tooltip>

        <FormControl className={classes.formControlComponent}  >

                  <TextField
                      id="fechareconocimiento"
                      label="Fecha de Reconocimiento"
                      type="date"
                      size="small" 
                      variant="outlined"
                      defaultValue="2022-03-10"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                />
       </FormControl>
       <Tooltip title="Fecha de reconocimiento, revalidación o habilitación del título o certificado de competencia">
                  <text style={{ color: '#0064AC', fontSize: 14, fontWeight: 'bold' }}>!</text>
          </Tooltip>

        </Grid>

      </>



  )
}

export default PasoDosForm